<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'familymembers.create'}"><i class="fa fa-plus"></i> Criar</router-link>
      <b-button class="btn btn-primary" @click="exportGrid()" ><i class="fa fa-download"></i> Exportar</b-button>
      <b-button class="btn btn-warning" @click="showSetFamilyMembersModal()" ><i class="fa fa-gear"></i> Acertar escalões</b-button>
    </div>
    <grid ref="personsPaginatedGridv3" name="personsPaginatedGridv3" :dataBound="dataBound" :preload="preload" height="calc(100vh - 250px)" :editable="true" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></grid>
  </b-card>

  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="typesModal" id="typesModal">
    <p v-if="!settingTypes">Vai acertar todos os escalões.</p>
    <p v-if="settingTypes">A acertar escalões.</p>
    <div slot="modal-footer" class="w-100">
      <b-btn  v-if="!settingTypes" size="sm" class="float-left" variant="secondary" @click="hideModalTypes">
        Cancelar
      </b-btn>
      <b-btn  v-if="!settingTypes" size="sm" class="float-right" variant="primary" @click="setFamilyMemberTypes">
        Continuar
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="typesModalDone" id="typesModalDone">
    <p >Os escalões foram acertados.</p>
    <div slot="modal-footer" class="w-100">
      <b-btn  v-if="!settingTypes" size="sm" class="float-right" variant="primary" @click="hideModalTypesDone">
        Continuar
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import States from '@/components/Lists.js'
import router from '@/router'

export default {
  name: 'personsPaginatedGrid',
  components: {
    Grid
  },
  data() {
    return {
      exporting: false,
      settingTypes: false,
      fileDownload: {
        url: '',
        title: ''
      },
      schemaModelFields: {
        'created_at': {
          type: 'date',
          editable: false
        },
        'id': {
          type: 'number',
          editable: false
        },
        'compound_key': {
          type: 'string',
          editable: false
        },
        'family_code': {
          type: 'number',
          editable: false
        },
        'surname': {
          editable: false
        },
        'birth_date': {
          editable: false,
          type: 'date'
        },
        'code': {
          type: 'number',
          editable: false
        },
        'latestFeeYear': {
          type: 'number',
          editable: false
        },
        'year_started': {
          type: 'number',
          editable: false
        }
      },
      url: 'familymembers/paginated',
      preload: [{
        api: 'familymembertypes/lst',
        field: 'family_member_type_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '80px',
        locked: true
      },
      {
        field: 'state',
        title: 'Estado',
        width: '180px',
        locked: false,
        values: States.states
      },
      {
        field: 'family_state',
        title: 'Estado Família',
        width: '180px',
        locked: false,
        values: States.states
      },
      {
        field: 'family_code',
        title: 'ID Família',
        width: '120px',
        locked: true
      },
      {
        field: 'surname',
        title: 'Apelido',
        width: '120px',
        locked: true
      },
      {
        field: 'family_member_type_id',
        title: 'Escalão',
        values: [],
        locked: true,
        width: '120px',
        attributes: {
          "class": 'family_member_type_id'
        }
      },
      {
        field: 'compound_key',
        title: 'ID Pessoa',
        width: '120px',
        locked: true
      },
      {
        field: 'name',
        title: 'Nome',
        width: '180px',
        locked: true
      },
      {
        field: 'birth_date',
        title: 'Data de Nascimento',
        width: '180px',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDatePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      },
      {
        field: 'nif',
        title: 'NIF',
        width: '180px'
      },
      {
        field: 'phone',
        title: 'Contacto',
        width: '180px'
      },
      {
        field: 'email',
        title: 'Email',
        width: '180px'
      },
      {
        field: 'family_email',
        title: 'Email Família',
        width: '180px'
      },
      {
        field: 'gender',
        title: 'Sexo',
        width: '180px',
        values: States.genders
      },
      {
        field: 'is_parent',
        title: 'Perfil Agregado',
        width: '120px',
        locked: false,
        values: States.isParent,
        attributes: {
          "class": 'is-parent'
        }
      },
      {
        field: 'is_veteran',
        title: 'Caloiro/Veterano',
        width: '120px',
        locked: false,
        values: States.isVeteran
      },
      {
        field: 'notes',
        title: 'Observações',
        width: '180px'
      },
      {
        field: 'year_started',
        title: 'Ano inscrição',
        width: '180px'
      },
      {
        field: 'latestFeeYear',
        title: 'Última quota',
        width: '180px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    showSetFamilyMembersModal: function() {
      this.$refs.typesModal.show()
    },
    hideModalTypes: function() {
      this.$refs.typesModal.hide()
    },
    hideModalTypesDone: function() {
      this.$refs.typesModalDone.hide()
    },
    exportGrid: function() {
      this.exporting = true
      var grid = this.$refs.personsPaginatedGridv3.$refs.mygrid.kendoWidget()
      console.log(grid.getOptions())
      this.axios.post('familymembers/export', {
        filter: grid.getOptions().dataSource.filter
      }).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        console.log(error)
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    },
    setFamilyMemberTypes: function() {
      this.settingTypes = true

      this.axios.post('familymembers/set_family_member_types').then(response => {
        this.$refs.typesModal.hide()
        this.$refs.typesModalDone.show()
        this.$refs.personsPaginatedGridv3.reload();
        this.settingTypes = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.settingTypes = false
        this.$refs.typesModal.hide()
      })
    },
    dataBound(a) {
      kendo.jQuery( ".is-parent" ).each(function( index ) {
        var dataItem = a.sender.dataItem(kendo.jQuery( this ).parent())
        if(dataItem.is_parent === 1) {
          $(this).parents('tr:first').addClass('is_parent')
        } else {
          $(this).parents('tr:first').addClass('is_child')
        }
      });
      kendo.jQuery( ".family_member_type_id" ).each(function( index ) {
        var dataItem = a.sender.dataItem(kendo.jQuery( this ).parent())
        console.log(dataItem)
        $(this).css('background-color', dataItem.family_member_type_color)
      });
    },
    getBtnTemplate: function(item) {
      if (this.$auth.check('familymembers.edit')) {
        var route = router.resolve({
          name: 'familymembers.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
      } else if (this.$auth.check('familymembers.view')) {
        var route = router.resolve({
          name: 'familymembers.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
      }
      return ''
    }
  }
}
</script>
